module.exports = __webpack_public_path__ + "media/images/smart_phone/past_order_history/ic_Order-a9f0fe7924158e0f72707f4cf30c30f8.png";